module.exports = new __parcel__URL__("satisfaction.c6f70195.svg").toString();